import { useDefaultProperties } from '@/hooks/DefaultPropertiesHook'
import ExozFooter from './ExozFooter'
import VirginFooter from './VirginFooter'
// TODO: tests
const FooterPicker = () => {
  const defaultProperties = useDefaultProperties()

  if (defaultProperties?.agentConfiguration?.handlerKey === 'virgin') {
    return <VirginFooter />
  }
  // No footer if it's a booking engine or a whitelabel
  if (defaultProperties?.agentConfiguration?.isBookingEngine || !defaultProperties?.agentConfiguration?.isBrgAgent) {
    return null
  }

  return <ExozFooter />
}

export default FooterPicker
